import Cookies from 'js-cookie'

export const authenticatedFetch = async (url, options = {}) => {
  const jwtToken = Cookies.get('jwt_token')
  
  const headers = {
    'Content-Type': 'application/json',
    ...(jwtToken && { Authorization: `Bearer ${jwtToken}` }),
    ...options.headers,
  }

  const response = await fetch(url, { ...options, headers })

  if (response.status === 401) {
    Cookies.remove('jwt_token', { path: '/' })
    if (window.location.pathname !== '/login') {
      window.location.replace('/login')
    }
    throw new Error('Unauthorized: Session expired or invalid token.')
  }

  return response
}
